export const wsConnect = host => ({ type: 'WS_CONNECT', host });
export const wsConnecting = host => ({ type: 'WS_CONNECTING', host });
export const wsConnected = host => ({ type: 'WS_CONNECTED', host });
export const wsDisconnect = () => ({ type: 'WS_DISCONNECT' });
export const wsDisconnected = host => ({ type: 'WS_DISCONNECTED', host });
export const wsSendNotification = payload => ({ type: 'WS_SEND_NOTIFICATION', payload });
export const wsSendMessage = payload => ({ type: 'WS_SEND_MESSAGE', payload });
